<template>
	<div :style="{ height: bodyHeight + 'px' }" class="shop m-body">
		<van-image
			width="100%"
			height="1rem"
			:src="require('@/assets/images/m_head.png')"
		></van-image>
		
		<ul class="list qjc-clearfix">
			<li v-for="item in list" :key="item.title" @click="to(item.url)" class="qjc-fl qjc-wid-50">
				<van-image
					width="100%"
					height="3.4rem"
					:src="require('@/assets/images/'+ item.img +'.png')"
				></van-image>
				<p class="qjc-fts-30 qjc-c-fff">{{ item.title }}</p>
			</li>
		</ul>
		
		<p class="foot qjc-fts-20">
			最终解释权归上海米因大数据科技有限公司所有
		</p>
		
		<m-footer></m-footer>
		
	</div>
</template>

<script>
	import Vue from 'vue'
	import { Image } from 'vant'
	Vue.use(Image);
	
	import MFooter from '@/components/m/Footer'
	
	export default{
		name: 'mShop',
		data() {
			return {
				bodyHeight: document.documentElement.clientHeight,
				
				list: [
					{ title: '鱼跃(YUWELL)低频理疗仪', img: 'yuwell', url: 'https://item.jd.com/100002314515.html' },
					{ title: '欧姆龙温热电极式低频理疗仪', img: 'omron', url: 'https://item.jd.com/100006108643.html' },
					{ title: '欧姆龙电子血压计', img: 'omron_hem7124', url: 'https://item.jd.com/1726938.html' },
					{ title: 'Move Free益节 氨糖维骨力', img: 'schiff', url: 'https://item.jd.hk/100009287096.html' },
					{ title: 'Swisse斯维诗 奶蓟草护肝片', img: 'swisse', url: 'https://item.jd.hk/1909882.html' },
					{ title: '金钙尔奇 碳酸钙维D3元素片', img: 'gaierqi', url: 'https://item.yiyaojd.com/4397416.html' },
					{ title: '三诺血糖试纸测试仪', img: 'sinocare', url: 'https://item.jd.com/4737030.html' },
					{ title: 'Swisse斯维诗男士复合维生素', img: 'swisse2', url: 'https://item.jd.hk/1909867.html' }
				]
			}
		},
		components: {
			MFooter
		},
		methods: {
			to(url) {
				window.location.href = url;
			}
		}
	}
</script>

<style lang="scss" scoped>
	.shop{
		padding-top: 0.08rem;
		padding-bottom: 1.5rem;
		
		.list{
			margin-top: 0.22rem;
			padding: 0 0.14rem;
			
			li{
				padding: 0 0.1rem;
				margin-bottom: 0.16rem;
				
				p{
					line-height: 0.36rem;
					padding: 0.12rem 0.08rem;
				}
			}
		}
		
		.foot{
			color: #6E7EA0;
			margin-top: 0.32rem;
			text-align: center;
		}
	}
</style>
